import script from "./CreateEinvoicePrepayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEinvoicePrepayment.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__